module.exports = __webpack_public_path__ + "static/media/default-image.8437f255.svg";